import { useTranslation } from "react-i18next";
import {
  PasswordType,
  validateWithUsernameAndPassword,
} from "@/schemas/forgotPassword";

import { FormStepProps } from "@/components/shared/Wizard/Wizard";
import { decryptPasswordWithRecoveryKey } from "@/middleware/forgotPassword";
import { UsernameStepData } from "./UsernameStep";
import { RecoveryPhraseType } from "@/schemas/recoveryKey";
import { PHRASE_WORDS_COUNT } from "@/config/constants";
import BaseConfirmPhraseStep from "../Common/BaseConfirmPhraseStep";
import { useToast } from "@/hooks/useToast";

export default function ConfirmPhraseForgotStep({
  onNext,
  onPrevious,
  onClose,
  formData,
  updateData,
}: FormStepProps<PasswordType>) {
  const { t } = useTranslation();
  const { toast } = useToast();
  const usernameData = formData?.userData as UsernameStepData;

  async function onSubmit(recoveryPhrase: RecoveryPhraseType) {
    try {
      const password = await decryptPasswordWithRecoveryKey(
        usernameData.username,
        recoveryPhrase.phrase.map((word) => word.toLowerCase()).join(" "),
        usernameData.encryptedPassword,
      );
      updateData(JSON.parse(password));
      onNext();
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    }
  }

  return (
    <BaseConfirmPhraseStep
      title={t("forgot.phraseTitle")}
      description={t("forgot.phraseDescription", {
        wordsCount: PHRASE_WORDS_COUNT,
      })}
      validator={{
        validate: validateWithUsernameAndPassword,
        validationParams: usernameData,
      }}
      onSubmit={onSubmit}
      onPrevious={onPrevious}
      onClose={onClose}
    />
  );
}
